export const SET_API_ERROR = 'SET_API_ERROR';
